import { ChatPageWrapper } from '@features/chat';
import { usePageTitle } from '@hooks/usePageTitle';
import { useTranslation } from 'react-i18next';

export const Chat = () => {
	const { t } = useTranslation();

	usePageTitle(t('chat'));

	return <ChatPageWrapper />;
};
